/**
 * Checkbox — shadcn Checkbox 어댑터
 *
 * 기존 @/ui Checkbox API를 유지한다.
 * shadcn Checkbox는 Radix 기반(onCheckedChange)이므로
 * 기존 onChange(checked: boolean) 시그니처와 브리지한다.
 */

import { Checkbox as ShadCheckbox } from '@/components/ui/checkbox'
import { cn } from './cn'

export interface CheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label?: string
  disabled?: boolean
  className?: string
}

export function Checkbox({
  checked,
  onChange,
  label,
  disabled = false,
  className,
}: CheckboxProps) {
  return (
    <label
      className={cn(
        'inline-flex items-center gap-2 cursor-pointer',
        disabled && 'opacity-50 cursor-not-allowed',
        className,
      )}
    >
      <ShadCheckbox
        checked={checked}
        disabled={disabled}
        // Radix onCheckedChange(next: boolean | 'indeterminate') → 기존 onChange(checked: boolean) 브리지
        onCheckedChange={(next) => {
          if (!disabled) onChange(next === true)
        }}
      />
      {label && <span className="text-sm text-foreground">{label}</span>}
    </label>
  )
}
